import React from 'react';
import Article from '../../styled-components/Article';
import H2 from '../../styled-components/H2';
import P from '../../styled-components/P';
import GalleryWrapper from '../../styled-components/GalleryWrapper';
import ArticleHeader from '../../styled-components/ArticleHeader';
import Hand from '../../styled-components/Hand';

import GalleryItem from '../../components/GalleryItem';
import LightWindow from '../../components/LightWindow';

import thumbsUp2 from '../../img/thumbs-up2.svg';
import img01 from '../../img/gallery/01.png';
import img02 from '../../img/gallery/02.png';
import img03 from '../../img/gallery/03.png';
import img04 from '../../img/gallery/04.png';
import img05 from '../../img/gallery/05.png';
import img06 from '../../img/gallery/06.png';

class Gallery extends React.Component {
  constructor() {
    super()
    this.state = {
      currentSlide: 0,
      zIndex: '3',
      showModal: false,
      hiddenBodyOverflow: false,
      window:{document:{body:{style:{overflow: ''}}}} }
  }
  componentDidMount() {
    if (typeof window !== `undefined`) {
      this.setState({window: window});
    }
  }
  render() {
    const showModal = index => {
      this.setState({
        currentSlide: index,
        showModal: true,
        zIndex: '10',
        hiddenBodyOverflow: true
      })
    }
    const hideModal = () => {
      this.setState({
        showModal: false,
        zIndex: '3',
        hiddenBodyOverflow: false
      })
    }
    const galleries = this.props.galleries.map((gallery, i) => {
      return (
        <GalleryItem
          key={i}
          bg={gallery.bg}
          title={gallery.title}
          showModal={() => showModal(i)}
        />
      );
    })
    this.state.hiddenBodyOverflow ? this.state.window.document.body.style.overflow = 'hidden' : this.state.window.document.body.style.overflow = 'auto';
    return (
      <div>
        <ArticleHeader
          hiddenBodyOverflow={{hidden: this.state.hiddenBodyOverflow, stateWindow: this.state.window}}>
          <H2>{this.props.title}</H2>
          <P>{this.props.description}</P>
          <Hand src={thumbsUp2} bottom="-50px" right="20px" hideOnMobile />
        </ArticleHeader>
        <GalleryWrapper style={{zIndex: this.state.zIndex}}>
          {galleries}
        </GalleryWrapper>

        <LightWindow
          hand={this.state.currentSlide}
          style={{position: 'relative'}}
          showModal={this.state.showModal}
          hideModal={() => hideModal()}
          slideIndex={this.state.currentSlide}>
          {this.props.galleries.map((gallery, i) => (
            <div key={i} className="inside">
              <H2>{gallery.title}</H2>
              <main>
                <P className="content" dangerouslySetInnerHTML={{__html: gallery.description}} />
                <img src={gallery.img} />
              </main>
            </div>
          ))}
        </LightWindow>
      </div>
    );
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Gallery/index.js